var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8008,
    cy: 14.778,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 15.63C21.8776 16.9569 21.3798 18.2214 20.5648 19.2756C19.7499 20.3299 18.6515 21.1302 17.3983 21.583C16.1451 22.0357 14.7888 22.1222 13.4883 21.8322C12.1877 21.5423 10.9966 20.8879 10.0544 19.9457C9.11218 19.0034 8.45781 17.8124 8.16785 16.5118C7.8779 15.2112 7.96436 13.855 8.41712 12.6018C8.86987 11.3485 9.6702 10.2502 10.7244 9.43524C11.7787 8.62029 13.0432 8.12246 14.3701 8C13.5942 9.05089 13.221 10.3453 13.3185 11.6479C13.416 12.9506 13.9776 14.175 14.9013 15.0987C15.825 16.0224 17.0495 16.5841 18.3521 16.6816C19.6548 16.779 20.9492 16.4059 22.0001 15.63Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonDark);
export default __webpack_public_path__ + "static/media/moonDark.7e4e02de8448fd36573c2d524f250290.svg";
export { ForwardRef as ReactComponent };